import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux"

import { logOut } from '../../redux/authSlice';
import { Avatar, Typography } from '@mui/material';
import { RootState } from '../../redux/store';
import { ChevronDown, LogOut } from 'lucide-react';

const DropdownUser = () => {
  const user = useSelector((store: RootState) => (store.auth))
  const disptach = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="relative">
      <Link
        to="#"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="flex items-center gap-2 cursor-pointer min-w-0"
      >
        <div className="hidden lg:flex flex-col items-end min-w-0 max-w-[200px]">
          <span className="text-sm font-medium text-white truncate w-full text-right">
            {user.userName}
          </span>
        </div>
        <Avatar>
          <Typography variant='body2' sx={{ fontSize: '1rem' }}>
            {user.userName.split(' ').map(el => el[0]).join('')}
          </Typography>
        </Avatar>
        <ChevronDown
          className={`transition-transform text-white duration-200 flex-shrink-0 ${dropdownOpen ? 'rotate-180' : ''}`}
        />
      </Link>

      {/* <!-- Dropdown Start --> */}
      <div
        ref={dropdown}
        onFocus={() => setDropdownOpen(true)}
        onBlur={() => setDropdownOpen(false)}
        className={`absolute right-0 mt-4 flex w-72 flex-col rounded-lg border border-gray-200 bg-white shadow-lg overflow-hidden ${dropdownOpen === true ? 'block' : 'hidden'
          }`}
      >
        {/* User Details Header */}
        <div className="px-5 py-4 bg-gray-50 border-b border-gray-200">
          <div className="flex  items-center gap-3">
            <Avatar sx={{ width: 48, height: 48 }}>
              <Typography variant='body1' sx={{ fontSize: '1.25rem' }}>
                {user.userName.split(' ').filter(Boolean).map(el => el[0]).join('').toUpperCase() || '?'}
              </Typography>
            </Avatar>
            <div className="flex flex-col min-w-0 flex-1">
              <span className="text-base font-semibold text-gray-900 truncate">
                {user.userName || 'Unknown User'}
              </span>
              {user.role && (
                <span className="text-sm text-gray-600 truncate">
                  {user.role}
                </span>
              )}
              {user.institutionName && (
                <span className="text-xs text-gray-500 truncate mt-0.5">
                  {user.institutionName}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Logout Button */}
        <div className="p-2">
          <button
            onClick={() => {
              disptach(logOut())
            }}
            className="flex items-center gap-3 w-full px-4 py-2.5 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-100 transition-colors duration-150">
            <LogOut className="h-4 w-4" />
            Log Out
          </button>
        </div>
      </div>
    </div >
  );
};

export default DropdownUser;
